import "src/decidim/vocdoni/election_status";
require.context("../images", true);
import "entrypoints/decidim_vocdoni.scss";
